import React from "react";
import { Row, ColumnStyled, InfoContainerStyled } from "./styles";
import { areEqual } from "react-window";
// @material-ui/core components
import Button from "components/CustomButtons/Button.js";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";

import "./styles.css";

const PriceItemList = React.memo(({ data, index, style }) => {
  const { color, prices, stationName, onOpenModal } = data;

  const item = prices[index];
  const { index: priceIndex, product, price } = item;

  return (
    <React.Fragment>
      <Row style={style}>
        <ColumnStyled width={25}>{product}</ColumnStyled>
        <ColumnStyled width={25}>{stationName}</ColumnStyled>
        <ColumnStyled width={20}>{priceIndex}</ColumnStyled>
        <ColumnStyled width={20}>${price}</ColumnStyled>
        <ColumnStyled position="center" width={10}>
          <InfoContainerStyled>
            <Button
              justIcon
              round
              simple
              color={color}
              onClick={() => onOpenModal(item)}
              className="edit"
            >
              <Edit />
            </Button>
          </InfoContainerStyled>
        </ColumnStyled>
      </Row>
    </React.Fragment>
  );
}, areEqual);

export default PriceItemList;
